import { sumBy } from 'lodash-es'

/**
 * Pemotongan (witholding) untuk struk cetak, disamakan dengan e-receipt BE.
 * `amount_after_tax` invoice & pembayaran dari BE sudah net setelah pemotongan.
 *
 * - Tampil (default, outlet lama tanpa opsi juga dianggap tampil): baris pemotongan dicetak,
 *   total & pembayaran dicetak apa adanya.
 * - Sembunyi (`print_style_show_witholding` = 0): baris tidak dicetak, total pemotongan
 *   ditambahkan kembali ke total tagihan dan ke baris pembayaran TERAKHIR saja,
 *   supaya struk tetap balance (subtotal item = total = pembayaran).
 */
export const getReceiptWitholding = (data, outletOptions = {}, fallbackLabel = '') => {
  // Nominal dari BE bisa berupa string desimal: paksa number supaya tidak tersambung sebagai string
  const witholdings = Array.isArray(data?.witholdings)
    ? data.witholdings.filter((row) => Number(row.witholding_amount) > 0)
    : []
  const totalWitholding = sumBy(witholdings, (row) => Number(row.witholding_amount) || 0)
  const isShown = `${outletOptions?.print_style_show_witholding ?? ''}` !== '0'
  const addBack = isShown ? 0 : totalWitholding

  const rows = isShown
    ? witholdings.map((row) => {
        // Snapshot nama master; baris tanpa master fallback ke nama akun
        const name = row.name || row.account?.name || fallbackLabel
        return {
          label: row.witholding_percent > 0 ? `${name} (${row.witholding_percent}%)` : name,
          amount: row.witholding_amount,
        }
      })
    : []

  return {
    rows,
    addBack,
    amountAfterTax: (Number(data?.amount_after_tax) || 0) + addBack,
    getPaymentAmount: (amount, index, paymentsLength) =>
      index === paymentsLength - 1 ? (Number(amount) || 0) + addBack : amount,
  }
}
